import React, { useState, useEffect } from "react";
import { Button, ProgressBar, Modal } from "react-onsenui";
import Select from "react-select";
import axios from "axios";
import Cookies from "js-cookie";
import HomeScreen from "./HomeScreen";
import { BASE_URL } from "../apiService";

const CustomInput = ({ label, placeholder, value, onChange }) => (
  <div style={{ marginBottom: 10 }}>
    <label
      style={{
        display: "block",
        marginBottom: 4,
        fontSize: 14,
        color: "black",
      }}
    >
      {label}
    </label>
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      style={{
        width: "100%",
        padding: "8px 10px",
        border: "1px solid gray",
        borderRadius: 5,
      }}
      required
    />
  </div>
);

const CustomSelect = ({ label, options, value, onChange, showMessage }) => (
  <div style={{ marginBottom: 10 }}>
    <label
      style={{
        display: "block",
        marginBottom: 4,
        fontSize: 14,
        color: "black",
      }}
    >
      {label}
    </label>
    {options.length > 0 ? (
      <Select 
      // menuPlacement="auto"
    minMenuHeight={120}
    // maxMenuHeight={100}
      options={options} value={value} onChange={onChange} />
    ) : (
      showMessage && (
        <div style={{ color: "red", fontSize: 12 }}>
          No Data found, Please contact the Administrator
        </div>
      )
    )}
  </div>
);

const RegistrationScreen = ({ navigator }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [registrationDetails, setRegistrationDetails] = useState({
    userName: "",
    state: null,
    district: null,
    block: null,
    panchayat: null,
    village: null,
  });
  const [locationData, setLocationData] = useState({
    districts: [],
    districtToBlocks: {},
    blockToPanchayats: {},
    panchayatToVillages: {},
  });
  const [error, setError] = useState("");

  const stateOptions = [
    { value: "hp", label: "Himachal Pradesh" },
    { value: "od", label: "Odisha" },
  ];

  useEffect(() => {
    if (registrationDetails.state) {
      const fetchLocationData = async () => {
        try {
          const response = await axios.get(
            `/jsons/${registrationDetails.state}.json`
          );
          console.log("Fetched location data:", response.data); // Debugging log
          const data = response.data;
          const STATE = stateOptions.find(
            (item) => item.value === registrationDetails?.state
          );

          setLocationData({
            districts: data[`StateToDistrict-${STATE.label}`],
            districtToBlocks: data,
            blockToPanchayats: data,
            panchayatToVillages: data,
          });
        } catch (error) {
          console.error("Failed to load location data", error);
        }
      };
      fetchLocationData();
    }
  }, [registrationDetails.state]);

  const handleChange = (field, value) => {
    const updatedDetails = { ...registrationDetails, [field]: value };
    if (field === "state") {
      updatedDetails.district = null;
      updatedDetails.block = null;
      updatedDetails.panchayat = null;
      updatedDetails.village = null;
      setLocationData({
        districts: [],
        districtToBlocks: {},
        blockToPanchayats: {},
        panchayatToVillages: {},
      });
    } else if (field === "district") {
      updatedDetails.block = null;
      updatedDetails.panchayat = null;
      updatedDetails.village = null;
    } else if (field === "block") {
      updatedDetails.panchayat = null;
      updatedDetails.village = null;
    } else if (field === "panchayat") {
      updatedDetails.village = null;
    }
    setRegistrationDetails(updatedDetails);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!registrationDetails.userName.trim()) {
      setError("Name is required.");
      return;
    }
    if (
      !registrationDetails.state ||
      !registrationDetails.district ||
      !registrationDetails.block ||
      !registrationDetails.panchayat ||
      !registrationDetails.village
    ) {
      setError("All fields are required.");
      return;
    }
    setError("");
    setIsSubmitting(true);

    try {
      const stateOBJ = stateOptions.find(
        (op) => op.value === registrationDetails.state
      );
      const name = registrationDetails?.userName;
      const payload = {
        ...registrationDetails,
        state: stateOBJ.label,
        name,
        postLevel: "सचिव",
      };

      const token = Cookies.get("RATIFI_REDUX_TOKEN");

      // Update user details
      const createdUserResponse = await axios.patch(
        `${BASE_URL}/update-user`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const ownerId = createdUserResponse.data.data?._id; // Assuming _id is returned in the response
      console.warn(createdUserResponse);
      // Submit claims
      const claimsPayload = { ownerId };
      const claimsResponse = await axios.post(
        `${BASE_URL}/claims`,
        {
          ownerId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      console.warn("claim", claimsResponse.data);
      // Extract claim number and save it in cookies
      const claimNumber = claimsResponse.data?.data?._id; // Assuming claimNumber is in the response
      const claimData = claimsResponse.data?.data; // Assuming the API returns claim data
      if (claimNumber) {
        const len = claimsResponse.data?.data?.claims?.length;
        Cookies.set("CLAIM_NUMBER", claimsResponse.data?.data?.claims[len - 1]); // Save claim number in cookies for 7 days
      } else {
        console.warn("Claim number not found in the response.");
      }

      // Save claim data in IndexedDB
      if (claimData) {
        await saveClaimToIndexedDB({ ...claimData, id: claimData?._id });
        console.log("Claim data saved to IndexedDB:", claimData);
      }

      // Navigate to the Home Screen
      navigator.pushPage({ title: "Home Screen", component: HomeScreen });
    } catch (error) {
      alert(`Submission failed: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const getOptions = (level) => {
    switch (level) {
      case "district":
        console.log("Districts:", locationData.districts); // Debugging log
        return (locationData.districts || []).map((dist) => ({
          value: dist,
          label: dist,
        }));
      case "block":
        return registrationDetails.district
          ? (
              locationData.districtToBlocks[
                `DistrictToBlock-${registrationDetails.district}`
              ] || []
            ).map((block) => ({
              value: block,
              label: block,
            }))
          : [];
      case "panchayat":
        return registrationDetails.block
          ? (
              locationData.blockToPanchayats[
                `BlockToPanchayat-${registrationDetails.block}`
              ] || []
            ).map((pan) => ({
              value: pan,
              label: pan,
            }))
          : [];
      case "village":
        return registrationDetails.panchayat
          ? (
              locationData.panchayatToVillages[
                `PanchayatToVillage-${registrationDetails.panchayat}`
              ] || []
            ).map((vil) => ({
              value: vil,
              label: vil,
            }))
          : [];
      default:
        return [];
    }
  };

  return (
    <div style={{ position: "relative", minHeight: "100vh" }}>
      {error && <div style={{ color: "red", marginBottom: 10 }}>{error}</div>}

      <div
        style={{
          padding: 10,
          paddingBottom: 60,
          overflowY: "auto",
          maxHeight: "calc(100vh - 60px)",
        }}
      >
        <CustomInput
          label="Name"
          placeholder="Enter your name"
          value={registrationDetails.userName}
          onChange={(e) => handleChange("userName", e.target.value)}
        />

        <CustomSelect
          label="State"
          options={stateOptions}
          value={stateOptions.find(
            (opt) => opt.value === registrationDetails.state
          )}
          onChange={(option) => handleChange("state", option.value)}
        />

        {registrationDetails.state && (
          <CustomSelect
            label="District"
            options={getOptions("district")}
            value={getOptions("district").find(
              (opt) => opt.value === registrationDetails.district
            )}
            onChange={(option) => handleChange("district", option.value)}
          />
        )}

        {registrationDetails.district && (
          <CustomSelect
            label="Block"
            options={getOptions("block")}
            value={getOptions("block").find(
              (opt) => opt.value === registrationDetails.block
            )}
            onChange={(option) => handleChange("block", option.value)}
            showMessage={true}
          />
        )}

        {registrationDetails.block && (
          <CustomSelect
            label="Panchayat"
            options={getOptions("panchayat")}
            value={getOptions("panchayat").find(
              (opt) => opt.value === registrationDetails.panchayat
            )}
            onChange={(option) => handleChange("panchayat", option.value)}
            showMessage={true}
          />
        )}

        {registrationDetails.panchayat && (
          <CustomSelect
            label="Village"
            options={getOptions("village")}
            value={getOptions("village").find(
              (opt) => opt.value === registrationDetails.village
            )}
            onChange={(option) => handleChange("village", option.value)}
            showMessage={true}
          />
        )}

        {/* {isSubmitting && (
          <div style={{ marginBottom: 10 }}>
            <ProgressBar indeterminate />
          </div>
        )} */}

        <Modal
          isOpen={isSubmitting}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "#5C7232",
              padding: "20px",
              borderRadius: "10px",
              width: "50%",
              marginLeft: "30%",
            }}
          >
            <div
              className="spinner-border"
              role="status"
              style={{ width: "3rem", height: "3rem" }}
            >
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </Modal>
      </div>

      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          backgroundColor: "#fff",
          padding: 10,
        }}
      >
        <Button
          onClick={handleSubmit}
          style={{
            width: "100%",
            backgroundColor: "#5C7232",
            color: "white",
          }}
        >
          SUBMIT
        </Button>
      </div>
    </div>
  );
};

export default RegistrationScreen;

const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("ClaimSyncDB", 1);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("claim-images")) {
        db.createObjectStore("claim-images", {
          keyPath: "id",
          autoIncrement: true,
        });
      }
      if (!db.objectStoreNames.contains("claims")) {
        db.createObjectStore("claims", { keyPath: "_id" });
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

const saveClaimToIndexedDB = async (claimData) => {
  try {
    const db = await openDB();
    const tx = db.transaction("claims", "readwrite");
    const store = tx.objectStore("claims");
    store.put(claimData);
    await tx.complete;
    console.log("Claim data saved to IndexedDB successfully.");
  } catch (error) {
    console.error("Failed to save claim data to IndexedDB:", error);
  }
};
